import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { LucideIcon } from './icons';
import { ACCENTS, type AccentKey } from '../theme/accents';
import { readableOn } from '../theme/templates';

export interface IconPillProps {
  icon: LucideIcon;
  accent: AccentKey;
  // solid = fond couleur + icône blanche/noire (contraste) ; soft = fond teinté + icône colorée.
  variant?: 'solid' | 'soft';
  size?: number;
  testID?: string;
}

// Pastille d'icône carrée arrondie — motif central de la refonte visuelle.
export function IconPill({ icon: Icon, accent, variant = 'solid', size = 44, testID }: IconPillProps) {
  const { vivid, soft } = ACCENTS[accent];
  const backgroundColor = variant === 'solid' ? vivid : soft;
  const iconColor = variant === 'solid' ? readableOn(vivid) : vivid;

  return (
    <View
      testID={testID}
      style={[styles.pill, { width: size, height: size, backgroundColor }]}
    >
      <Icon size={Math.round(size * 0.5)} color={iconColor} strokeWidth={2} />
    </View>
  );
}

const styles = StyleSheet.create({
  pill: {
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
